//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 29.02.2016.
 */
(function () {

        'use strict';

        angular.module('container.core')
            .factory('authenticationService', authenticationService);

        function authenticationService($rootScope, $timeout, Event) {

            let keycloakService = window._keycloak;

            init();

            function init() {

                $timeout(() => {
                    if (keycloakService.authenticated) {
                        $rootScope.$emit(Event.USER_LOGGED_IN);
                    }
                }, 1000);

                keycloakService.loadUserProfile(function() {
                    console.log('Loading user profile successful!');
                }, function() {
                    console.log('Failed to retrieve user details. Please enable claims or account role');
                });

            }

            return keycloakService;
        }
    })();